import {createContext} from 'react';

export const DEFAULT_SPEAKER_STATE = {
  speaking: false,
  setSpeaking: () => null,
};

export const SpeakerContext = createContext(DEFAULT_SPEAKER_STATE);
